// extracted by mini-css-extract-plugin
export default {"sheets":"style_sheets__JjC+z"};